import { createParser } from 'nuqs';

/**
 * Parses a URL query value as a timestamp in milliseconds.
 * Accepts either a numeric string (JS timestamp) or an ISO 8601 date string.
 * Returns null for missing, empty, or invalid values.
 */
function parseTimestamp(value: string | null | undefined): number | null {
  if (value == null || value === '') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  // Numeric string (JS timestamp in ms)
  if (/^\d+$/.test(trimmed)) {
    const n = Number(trimmed);
    return Number.isFinite(n) ? n : null;
  }

  // ISO string or other date string
  const ms = Date.parse(trimmed);
  return Number.isNaN(ms) ? null : ms;
}

/**
 * nuqs parser for logger URL params (cursor, from, to).
 * Accepts ISO strings or JS timestamps; serializes as timestamp string.
 */
export const parseAsTimestamp = createParser<number | null>({
  parse: parseTimestamp,
  serialize(value) {
    return value == null ? '' : String(value);
  },
  eq(a, b) {
    return a === b || (a == null && b == null);
  },
});
